import {html} from '@isceco/widget-library2/external/lit'
import WebComponent from '../../WebComponent.js'
import AuthorizationFilter from '../Authorization/AuthorizationFilter'
import BerechtigungUtil from '../../services/BerechtigungUtil'
import './GP/GPDashboard'
import './VNB/VNBDashboard'
import './OSTRALDashboard'
import './BWLDashboard'

export default class Startseite extends WebComponent {

  constructor() {
    super()
    this.berechtigungUtil = new BerechtigungUtil()
  }

  get translationFile() {
    return './views/Dashboard/i18n.json'
  }

  connectedCallback() {
    super.connectedCallback()
    this.render()
  }

  getTemplate() {
    const authFilter = new AuthorizationFilter()
    if(authFilter.hasOnlyGeneric() && this.berechtigungUtil.getUserProfiles().length === 0) {
      return html`<eko-frontend-onboarding></eko-frontend-onboarding>`
    } else if (authFilter.roles.GP) {
      return html`<eko-frontend-gp-dashboard></eko-frontend-gp-dashboard>`
    } else if (authFilter.roles.VNB) {
      return html`<eko-frontend-vnb-dashboard></eko-frontend-vnb-dashboard>`
    } else if (authFilter.roles.OSTRAL) {
      return html`<eko-frontend-ostral-dashboard></eko-frontend-ostral-dashboard>`
    } else if (authFilter.roles.BWL) {
      return html`<eko-frontend-bwl-dashboard></eko-frontend-bwl-dashboard>`
    } else {
      return html``
    }
  }

}
customElements.define('eko-frontend-startseite', Startseite)
